<template>
    <v-card class="specialist-wrapper" @click="$emit('click', item)">
        <provider-stats with-specialties :provider="item"></provider-stats>
        <v-btn v-if="currentUser && currentUser.super" class="account-btn" fab small depressed
               color="accent" @click.stop="$emit('config', item.id)">
            <v-icon size="14">fas fa-users-cog</v-icon>
        </v-btn>
    </v-card>
</template>

<script>
import ProviderStats from './ProviderStats'
import {mapState} from "vuex";

export default {
    components: {ProviderStats},
    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapState(['currentUser']),
    },
}
</script>

<style scoped>

.specialist-wrapper {
    position: relative;
    background-color: rgba(255, 255, 255, .7);
    transition: .1s all
}

.specialist-wrapper:hover {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.3);
    transform: scale(1.01)
}

.account-btn {
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 10;
    width: 30px;
    height: 30px;
}

</style>